export const CARACTERISTICA_PRODUTO_LOAD = "CARACTERISTICA_PRODUTO_LOAD";
export const CARACTERISTICA_PRODUTO_LIST = "CARACTERISTICA_PRODUTO_LIST";
export const CARACTERISTICA_PRODUTO_CREATE = "CARACTERISTICA_PRODUTO_CREATE";
export const CARACTERISTICA_PRODUTO_UPDATE = "CARACTERISTICA_PRODUTO_UPDATE";
export const CARACTERISTICA_PRODUTO_DELETE = "CARACTERISTICA_PRODUTO_DELETE";
